// extracted by mini-css-extract-plugin
export var actionRequired = "InfoBoxBase-module__actionRequired___YWegG";
export var actionRequiredLink = "InfoBoxBase-module__actionRequiredLink___UCrbJ";
export var containerRow = "InfoBoxBase-module__containerRow___iK0Cy";
export var large = "1084px";
export var medium = "860px";
export var small = "540px";
export var subtitleColumn = "InfoBoxBase-module__subtitleColumn___fpMMv";